// Authentication
export const AUTH_LOADED = 'AUTH_LOADED';
export const AUTH_LOADING = 'AUTH_LOADING';

// User
export const NEW_USER = 'NEW_USER';
export const SIGN_IN_USER = 'SIGN_IN_USER';
export const SIGN_OUT_USER = 'SIGN_OUT_USER';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';

// Groups
export const GET_GROUP_DETAILS = 'GET_GROUP_DETAILS';
export const SET_GROUP_MEMBERS = 'SET_GROUP_MEMBERS';
export const SET_GROUPS = 'SET_GROUPS';
export const CLEAR_GROUPS = 'CLEAR_GROUPS';
export const UPDATE_LIST_CONFIG = 'UPDATE_LIST_CONFIG';
export const GROUPS_FETCHED = 'GROUPS_FETCHED';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const DELETE_GROUP = 'DELETE_GROUP';
export const GROUPS_LOADING = 'GROUPS_LOADING';

// Posts
export const GET_POSTS = 'GET_POSTS';
export const SET_POSTS = 'SET_POSTS';
export const SET_POST_TAGS_LIST = 'SET_POST_TAGS_LIST';
export const SET_POST_GROUPS_LIST = 'SET_POST_GROUPS_LIST';
export const SET_POSTS_HIGHLIGHTS = 'SET_POSTS_HIGHLIGHTS';
export const SET_POST_HIGHLIGHTS = 'SET_POST_HIGHLIGHTS';
export const SET_POST_NOTE = 'SET_POST_NOTE';
export const SET_SELECTED_POST = 'SET_SELECTED_POST';
export const GET_SELECTED_POST = 'GET_SELECTED_POST';
export const UPDATE_POST_LIST_CONFIG = 'UPDATE_POST_LIST_CONFIG';
export const SET_SELECTED_POST_DATE = 'SET_SELECTED_POST_DATE';
export const SET_POST_GROUP = 'SET_POST_GROUP';
export const SET_POST_TITLE = 'SET_POST_TITLE';
export const SET_LINK_URL = 'SET_LINK_URL';
export const SET_POST_TAGS = 'SET_POST_TAGS';
export const SET_POST_STATUS = 'SET_POST_STATUS';
export const UPDATE_POST_LIST = 'UPDATE_POST_LIST';
export const SET_POST_CONTENT = 'SET_POST_CONTENT';
export const UPDATE_POST_HIGHLIGHT = 'UPDATE_POST_HIGHLIGHT';
export const DELETE_HIGHLIGHT = 'DELETE_HIGHLIGHT';

// LEADERS
export const SET_LEADERS_LIST = 'SET_LEADERS_LIST';
export const SET_LEADER_SEARCH_TERM = 'SET_LEADER_SEARCH_TERM';
export const SET_LEADER_GROUPS = 'SET_LEADER_GROUPS';
export const SET_FOLLOW_LIST = 'SET_FOLLOW_LIST';
export const SET_FOLLOWED_GROUPS = 'SET_FOLLOWED_GROUPS';
export const SET_ALL_GROUPS_FOR_FOLLOWED_LEADERS = 'SET_ALL_GROUPS_FOR_FOLLOWED_LEADERS';
export const SET_FOLLOWED_POSTS = 'SET_FOLLOWED_POSTS';
export const SET_FOLLOW_FILTER = 'SET_FOLLOW_FILTER';
export const UPDATE_FOLLOW_LIST = 'UPDATE_FOLLOW_LIST';
export const REMOVE_FOLLOWED_GROUP = 'REMOVE_FOLLOWED_GROUP';
export const RESET_LEADERS_PAGE = 'RESET_LEADERS_PAGE';

// Library
export const CLEAR_LIBRARY = 'CLEAR_LIBRARY';
export const SET_LIBRARY_LIST = 'SET_LIBRARY_LIST';
export const SET_LIBRARY_LIST_CONFIG = 'SET_LIBRARY_LIST_CONFIG';
export const SET_MORE_LIBRARY_POSTS = 'SET_MORE_LIBRARY_POSTS';
export const REMOVE_LIBRARY_ITEM = 'REMOVE_LIBRARY_ITEM';
export const SET_LIBRARY_NOTE = 'SET_LIBRARY_NOTE';

// APP
export const SET_APP_LOADING = 'SET_APP_LOADING';
